<template>
  <div
    v-editable="blok"
    class="relative h-full flex flex-col clamp-gap-4-8 text-[--text-color]"
    :style="{ '--text-color': backgroundColor.hexFg }">
    <div
      v-if="blok.media?.length"
      class="relative text-center clamp-max-h-70-140 clamp-mx-4-8 clamp-mb-neg-8-16 z-10">
      <div
        class="relative group h-full"
        :class="{ 'inline-flex': !isCarousel, flex: isCarousel }"
        @click="toggleOverlay">
        <ElementMedia
          :bloks="blok.media"
          ratio="orig"
          :sizes="sizes"
          class="w-auto h-full"
          :class="{ 'clamp-rounded-8-10': roundedMedia }" />
        <ElementOverlay
          v-if="hasOverlay && !isCarousel"
          :blok="blok"
          :sizes="sizes"
          :isOverlayVisible="isOverlayVisible"
          class="absolute inset-0 z-20 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          :class="{ 'clamp-rounded-8-10': roundedMedia }" />
      </div>
    </div>

    <div
      class="relative flex-1 clamp-px-4-8 clamp-py-8-16 bg-[--bg-color] clamp-rounded-8-10"
      :style="{ '--bg-color': backgroundColor.hex }"
      v-if="blok.texts?.length">
      <ElementTexts
        :bloks="blok.texts"
        class="element-texts-my-sm text-max-w-card h-full"
        textPosition="center"
        buttonSize="sm"
        buttonAlignment="bottom" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from "vue";
import { ElementCardsCardStoryblok } from "@/types";
import { ImgSizes } from "@/components/atoms/AImage.vue";
import { ISbPluginThemeColorPicker } from "@/types";

interface Props {
  blok: ElementCardsCardStoryblok;
  sizes: ImgSizes;
  roundedMedia?: boolean;
  isCarousel?: boolean;
}
const props = defineProps<Props>();

const backgroundColor = computed(
  () => props.blok.backgroundColor as ISbPluginThemeColorPicker
);
const hasOverlay = computed(() => (props.blok.overlay ?? []).length > 0);

const isOverlayVisible = ref(false);

const toggleOverlay = (event: Event) => {
  isOverlayVisible.value = !isOverlayVisible.value;
};

const closeOverlay = () => {
  isOverlayVisible.value = false;
};

onMounted(() => {
  document.addEventListener("click", closeOverlay);
});
onUnmounted(() => {
  document.removeEventListener("click", closeOverlay);
});
</script>
